// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1NZJc","modalFooterButton":"ModalNotes_modalFooterButton__Zb7Wg"};